import { EEnv } from "./enums";
import {  
	IVehicle, 
	IVehicleImages, 
	IVehiclePricing, 
	IEnquiryPost, 
	ITestDriveOption,
	ISupplierNavItem
} from "./types";
import { getCookie, env } from '@/helpers';

export const baseUrl = env == EEnv.staging || env == EEnv.qa ? 'https://stagingapp.toyotainventory.com.au/' : 'https://app.toyotainventory.com.au/';

const fslApi = 'https://fslclient.azurewebsites.net/';

export const getFslURL = (): string => {
	return `${fslApi}FSLResult`;
};

export const getSupplierNav = async (dealerId: number): Promise<Array<ISupplierNavItem>> => {
	const url = `${baseUrl}api/suppliernav/${dealerId}`;
	return await fetch(url).then(response => {
		return response.json();
	}).catch(error => {
		console.log(error);
		return [];
	});	
};

export const getTestDriveVehicles = async (hash: string, stockDealerId: number): Promise<Array<ITestDriveOption>> => {
	const url = `${baseUrl}api/TestDriveOption?material=${hash}&stockDealerID=${stockDealerId}&_=${new Date().valueOf()}`;
	return await fetch(url).then(response => {
		return response.json();
	}).catch(error => {
		console.log(error);
		return [];
	});	
};

export const getDemoVehicleImages = async (id: number, batch: string) => {
	const url = baseUrl + `api/DemoImage?id=${id}&batch=${batch}&_=${new Date().valueOf()}`;
	return await fetch(url).then(response => {
		return response.json();
	}).catch(error => {
		console.log(error);
		return null;
	});	
}

export const getVehicleImages = async (hash: string, planned: string | undefined): Promise<IVehicleImages> => {
	const imageApi = baseUrl + "api/InventoryImagev2/";
	const url = `${imageApi}?id=${hash}${env == EEnv.qa ? '&preRelease=true' : ''}${typeof planned != 'undefined' ? ('&plannedMonth='+planned) : ''}${env == EEnv.qa ? '&preRelease=true' : ''}&_=${new Date().valueOf()}`;

	return await fetch(url).then(response => {
		return response.json();
	}).catch(error => {
		console.log(error);
		return null;
	});	
}

export const getVehiclePricing = async (vehicle: IVehicle, materialCode: string, fakeSpecial?: boolean): Promise<IVehiclePricing> => {
	const financeApi = baseUrl + "api/VirtualStockSummary";
	const params = new URLSearchParams();
	const guid = getCookie('tprguid');
	const financeoptions = getCookie('financeoptions').split('_');

	params.set('materialCode', materialCode);
	params.set('vehicle_specification_id', vehicle.VsId.toString());
	params.set('dealerid', vehicle.Dealer.DealerId.toString());
	if (env == EEnv.qa){
		params.set('ignoreRelease', 'true');
	}
	params.set('actualdealerid', vehicle.Dealer.ActualDealerId.toString());
	params.set('fulldescription', vehicle.FullDescriptionForFinance);
	if (fakeSpecial){
		params.set('fakeSpecial', 'true');
	}
	guid && params.set('personalised', guid);
	
	if (financeoptions.length == 3){
		params.set('deposit', financeoptions[0]);
		params.set('term', financeoptions[1]);
		params.set('kms', financeoptions[2]);
	}
	
	params.set('_', (new Date().valueOf()).toString());

	return await fetch(`${financeApi}?${params.toString()}`)
	.then(response => {
		return response.json();
	}).catch(error => {
		console.log(error);
		return null;
	});	
}

export const postEnquiryForm = async (data: IEnquiryPost, token: string): Promise<any> => {
	const postUrl =  "/api/EnquiryIndividualNewVehicle";
	const url = location.href.includes("localhost:") ? `http://test.dealer.toyota.com.au${postUrl}` : postUrl;

	const headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		RequestVerificationToken: token
	}
	console.log('headers', headers);
	return await fetch(url, {
		method: 'POST',
		headers, 
		body: JSON.stringify(data)
	})
	.then(response => {
		return response;
	}).catch(error => {
		console.log(error);
		return false;
	});	
}
export const postTestDriveForm = async (data: IEnquiryPost, token: string): Promise<any> => {
	const postUrl =  "/api/EnquiryTestDrive";
	const url = location.href.includes("localhost:") ? `http://test.dealer.toyota.com.au${postUrl}` : postUrl;

	const headers: any = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		RequestVerificationToken: token
	};
	console.log('headers', headers);
	return await fetch(url, {
		method: 'POST',
		headers,
		body: JSON.stringify(data)
	})
	.then(response => {
		return response;
	}).catch(error => {
		console.log(error);
		return false;
	});	
}